import axios from "./api";

const base = "/business/payment";

const Payment = {
  addAccount(payment) {
    return axios.post(base + "/stripe-account", payment);
  },
  getWelcomeCheckoutURL(request) {
    return axios.post(base + "/checkout-url-welcome", request);
  },
  getSubscribePlan() {
    return axios.get(`business/plan-list`);
  },
  getLatestSubscriptionInfo() {
    return axios.get("business/subscription");
  },
  getStripeCustomerID(companyId, locationId) {
    return axios.get(`business/stripe-customer/${companyId}/${locationId}`);
  },
  getSubscriptionDetailsFromCustomerId(stripe_customer_id) {
    return axios.get(`business/business-subscription/${stripe_customer_id}`);
  },
  getPayout(companyId, locationId) {
    return axios.get(`business/invoices/${companyId}/${locationId}`);
  },
  // Stripe Widget Integration Methods
  createBillingPortalSession(customerId) {
    return axios.post("/business/stripe/login-link", {
      stripe_customer_id: customerId,
    });
  },
  cancelStripeSubscription(subscription_id) {
    return axios.post("business/stripe/subscription/cancel", {
      subscription_id,
    });
  },
};

export default Payment;
